import { Clickable } from '@carvana/merch-components';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useCallback, useContext, useState } from 'react';
import { COOKIES } from '~/constants';
import ModalContext from '~/contexts/ModalContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import StaticContext from '~/contexts/StaticContext';
import Close from '~/icons/Close';
import BrowserCookies from '~/utilities/BrowserCookies';
import {
  BackgroundImg,
  Container,
  GreenCirlce,
  LargeText,
  MainContent,
  PlugIcon,
  TextSection
} from './EVBanner.styles';

enum DismissedEV {
  None = 0,
  Banner = 1
}

function setBannerDismissedCookie(value) {
  const oneYear = 365 * 24 * 60 * 60 * 1000;
  const expires = new Date(Date.now() + oneYear);

  BrowserCookies.set(COOKIES.dismissedEVBanner, String(value), {
    expires,
    path: '/'
  });
}

export default function EVBanner() {
  const { setEVTaxCreditModalOpen } = useContext(ModalContext);
  const { dismissedEVBanner } = useContext(StaticContext);
  const [localDismissedEV, setLocalDismissedEV] =
    useState<DismissedEV>(dismissedEVBanner);
  const trackEvent = useTrackEvent();

  const setBannerDismissed = useCallback(dismissed => {
    setBannerDismissedCookie(dismissed);
    setLocalDismissedEV(dismissed);
  }, []);

  const showEVBanner = localDismissedEV < DismissedEV.Banner;

  useEffectOnce(
    () => {
      trackEvent('Viewed - EV Banner');
    },
    [trackEvent],
    showEVBanner
  );

  return showEVBanner ? (
    <Container data-qa="ev-banner">
      <BackgroundImg
        src={`${process.env.CVNA_APP_ASSETS_CDN}/search-assets/ev-banner/background.png`}
        alt="banner gradient wave background "
      />

      <MainContent>
        <GreenCirlce>
          <PlugIcon />
        </GreenCirlce>

        <TextSection>
          <LargeText>SAVE UP TO $4,000 ON USED EV’s</LargeText>
          <Clickable
            className="!underline text-base text-blue-6"
            data-analytics-id="EV - Learn More"
            data-qa="ev-banner-learn-more"
            element="span"
            onClick={() => setEVTaxCreditModalOpen(true)}
          >
            Learn More
          </Clickable>
        </TextSection>

        <section>
          <img
            className="hidden ml-auto w-full m:block"
            src={`${process.env.CVNA_APP_ASSETS_CDN}/search-assets/ev-banner/vehicle.png`}
            alt="White car with Carvana halo"
          />
        </section>
      </MainContent>

      <Clickable
        data-analytics-id="EV - Close Banner"
        data-qa="close-ev-banner"
        onClick={() => setBannerDismissed(DismissedEV.Banner)}
        className="absolute flex h-[36px] items-center justify-center right-4 top-4 w-[36px]"
      >
        <Close className="fill-blue-6" width={'24px'} height={'24px'} />
      </Clickable>
    </Container>
  ) : null;
}
